import type { HelpFile } from '../../types/help'
import { TypeScopeSelectorTestIds } from '../../../testids/TypeScopeSelectorTestIds'

export const typeScopeSelectorHelp: HelpFile = {
  docPage: '/docs/schema/attribute-definitions',
  texts: {
    [TypeScopeSelectorTestIds.typeScopeAll]: 'Dieses Attribut oder diese Regel auf jeden Typ anwenden. Es ist keine weitere Auswahl nötig.',
    [TypeScopeSelectorTestIds.typeScopeSpecific]: 'Dieses Attribut oder diese Regel auf die unten ausgewählten Typen einschränken.',
    [TypeScopeSelectorTestIds.typeScopeAdd]: 'Einen weiteren Typ zum Geltungsbereich hinzufügen.',
  },
}
